import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRockClimbingNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M28.53 18.06L15.73 7.78a2.662 2.662 0 00-1.62-.57 2.574 2.574 0 00-2.28 1.38l-1.92 3.6a1.69 1.69 0 01-1.5.9h-.59l-1.24-2.34.99-1.18a2.238 2.238 0 10-3.69-.38l.7 1.31-.17.17A14.255 14.255 0 00.19 20.84a5.006 5.006 0 005 4.99c.797 0 1.588-.15 2.33-.44a11.9 11.9 0 014.45-.86h.61c1.179.001 2.353.139 3.5.41l12.1 2.86a2.985 2.985 0 002.52-.55 3.017 3.017 0 001.13-2.33 8.74 8.74 0 00-3.3-6.86zM5.35 7.84a.574.574 0 01.5-.28.563.563 0 01.53.34.585.585 0 01-.08.62l-.56.66-.41-.76a.579.579 0 01.02-.58zm-.16 16.34a3.355 3.355 0 01-3.35-3.34 12.53 12.53 0 01.5-3.52l3.61 6.79c-.25.049-.505.072-.76.07zm2.359-.569l-4.43-8.33a12.452 12.452 0 012.271-3.25l5.79 10.88c-1.237.062-2.46.298-3.631.7zm22.621 1.31a1.308 1.308 0 01-.49 1.03 1.331 1.331 0 01-1.12.25l-12.1-2.87a17.12 17.12 0 00-3.42-.44l-1.25-2.35 18.38 4.35v.03zm-.22-1.78L10.76 18.6l-2.07-3.88a3.344 3.344 0 002.68-1.75l1.91-3.61a.968.968 0 011.41-.29l1.59 1.28-5.31 6.61 1.77.42 4.84-6 1.36 1.1-4.27 5.36 1.78.42 3.78-4.75 1.4 1.12-3.28 4.08 1.78.42 2.78-3.47 1.39 1.12-2.27 2.8 1.78.43 1.78-2.2 1.91 1.53a7.135 7.135 0 012.45 3.8z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsRockClimbingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRockClimbingNormalMedium;
